import {Button} from '@mui/material';
import React, {Fragment} from 'react';

import {BookingScheduledEnum} from 'main/analytics/gaTagsEnum';
import {AlertModal, TagChip} from 'presentation/components';
import {OperationStateTypesEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';

import {AppointmentsConfirmModal} from '../AppointmentsConfirmModal';
import {useConfirmToGoButton} from './hooks/useConfirmToGoButton';
import {ConfirmToGoButtonProps} from './types';

const {appointmentCard, confirmAppointmentModal, confirmAppointmentError} =
	translations['pt-br'].privateFlow.myAppointments;

const {confirmation} = translations['pt-br'].commons;

export function ConfirmToGoButton({appointment, variant = 'chip'}: ConfirmToGoButtonProps) {
	const {
		showConfirmButton,
		isPending,
		isError,
		isSubmitting,
		handleConfirm,
		description,
		setConfirmState,
	} = useConfirmToGoButton(appointment);

	if (!showConfirmButton) {
		return null;
	}

	const confirmedButton =
		variant === 'chip' ? <TagChip label={appointmentCard.confirmed} color="success" /> : null;

	return (
		<Fragment>
			{appointment.isConfirmed ? (
				confirmedButton
			) : (
				<Button
					variant={variant === 'chip' ? 'outlined' : 'contained'}
					size={variant === 'chip' ? 'small' : 'large'}
					onClick={() => setConfirmState(OperationStateTypesEnum.PENDING)}
					data-tag-id={BookingScheduledEnum.CLICK_CONFIRMAR_PRESENCA}>
					{confirmAppointmentModal.actionButtonText}
				</Button>
			)}

			<AppointmentsConfirmModal
				open={isPending || isSubmitting}
				isDisabled={isSubmitting}
				isSubmitting={isSubmitting}
				subTitle={description()}
				handleAction={handleConfirm}
				onClose={() => setConfirmState(OperationStateTypesEnum.NONE)}
				onOpen={() => setConfirmState(OperationStateTypesEnum.PENDING)}
				appointment={appointment}
			/>

			<AlertModal
				description={confirmAppointmentError.description}
				headerTitle={confirmation}
				title={confirmAppointmentError.title}
				onClose={() => setConfirmState(null)}
				open={isError}
				variant="info"
			/>
		</Fragment>
	);
}
